// src/components/races/detail/raceDetail.tsx
import { useState } from "react";
import { type RaceWithParticipants } from "@/backend/domain/race/getRace";
import { RaceStats } from "./raceStats";
import { RaceFiles } from "./raceFiles";
import { RaceDetailTabs } from "./raceDetailTabs";
import LoadingButton from "@/components/shared/other/loadingButton";

interface RaceDetailProps {
    race: RaceWithParticipants;
}

export function RaceDetail({ race }: RaceDetailProps) {
    const [searchTerm, setSearchTerm] = useState("");

    return (
        <div className="max-w-6xl mx-auto px-6 py-24 md:py-24">
            <div className="space-y-8 md:space-y-12 pt-8">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-6">
                    <div className="space-y-6">
                        <h1 className="text-3xl md:text-4xl font-light tracking-tighter">
                            {race.name}
                        </h1>
                        <RaceStats race={race} />
                        {race.files.length > 0 && (
                            <RaceFiles race={race} />
                        )}
                    </div>

                    {race.status === 'REGISTRATION_OPEN' && (
                        <LoadingButton
                            action={`/register/${race.id}/register-type`}
                            className="w-full md:w-auto px-6 py-4 md:px-8 md:py-6
                                     bg-gradient-to-r from-slate-800 to-slate-700
                                     text-white hover:from-slate-900 hover:to-slate-800
                                     font-light tracking-wider shadow-lg hover:shadow-xl
                                     transition-all duration-300"
                            loadingText="LADEN..."
                        >
                            ANMELDUNG
                        </LoadingButton>
                    )}
                </div>

                {/* Content Section */}
                <RaceDetailTabs
                    race={race}
                    searchTerm={searchTerm}
                    onSearch={setSearchTerm}
                />
            </div>
        </div>
    );
}
